// tslint:disable-next-line:no-shadowed-variable
import { ConfigModel } from '../core/interfaces/config';

// tslint:disable-next-line:no-shadowed-variable
export class MenuConfig implements ConfigModel {
	public config: any = {};

	constructor() {
		this.config = {
			header: {
				self: {},
				items: []
			},
			aside: {
				self: {},
				items: [
					{
						title: 'Dashboard',
						desc: 'Some description goes here',
						root: true,
						icon: 'flaticon-line-graph',
						page: '/',
						translate: 'MENU.DASHBOARD'
					},
					{ section: 'UEX' },
					{
						title: 'My Backoffice',
						bullet: 'dot',
						icon: 'flaticon-business',
						root: true,
						submenu: [
							{
								title: 'Company list',
								page: '/bo/company'
							},
							{
								title: 'Policy list',
								page: '/bo/policy'
							},
							{
								title: 'User list',
								page: '/bo/user'
							},
							{
								title: 'Renewal Notice',
								page: '/bo/renewal-notice'
							}
						]
					}
				]
			}
		};
	}
}
